import React, { FunctionComponent } from 'react';
import styles from './button-loader.module.scss';

export interface IButtonProps {
  buttonText: string;
  onClick: (event: React.MouseEvent<HTMLElement>) => void;
}

export const ButtonLoader: FunctionComponent<IButtonProps> = ({
  buttonText,
  onClick
}) => {
  return (
    <div data-theme="theme-black">
      <button className={styles.buttonLoader} onClick={onClick}>
        <div className={styles.content}>
          {buttonText}
          <i className={`${styles.arrowIcon} material-icons md-20`}>add</i>
        </div>
      </button>
    </div>
  );
};
